<div>
  <div class="top-line"></div>
  <div class="col-12 head-dialog d-flex align-items-center"
       style="padding: 12px 16px!important;">
    <div (click)="noAction()"
         style="width: 24px;height: 30px;margin-left: 16px">
      <svg class="sc-imWYAI iXeikx"
           fill="inherit"
           size="24"
           viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.439 19.499 12 13.06l-6.438 6.438-1.061-1.061L10.94 12 4.502 5.562l1.06-1.06 6.439 6.437 6.438-6.438 1.06 1.061L13.061 12l6.438 6.438-1.06 1.06Z"
          fill="inherit"></path>
      </svg>
    </div>
    <span>{{ 'FactorOrder' | translate }}</span>
  </div>
  <div class="co-12 parent-factor-dialog">
    <div style="overflow: scroll;">
      @for (factorOrder of data.FactorOrders; track $index) {
        <div class="align-items-center"
             style="padding: 10px 16px">
          <div class="d-flex service justify-content-between">
            <span>{{ factorOrder.Order.ServicePrice.Service.Title | translate }}</span>
            <div class="d-flex gap-1">
              <p
                style="font-size: 12px!important;color: rgba(19, 20, 31, 0.9)!important;">{{ (parseInt(factorOrder.Order.Count) > 1 ? (factorOrder.Order.Count + '×') : '') }}
              </p>
              <p
                style="font-family: IRANSansWebBold!important;">{{ StringUtil.numberAsCurrency(factorOrder.Order.ServicePrice.Price ?? 0) + ' ریال' }}
              </p>
            </div>
          </div>
          @if (factorOrder?.Order?.OrderServicePriceAdditives?.length > 0) {
            @for (orderServicePriceAdditive of factorOrder.Order.OrderServicePriceAdditives; track $index) {
              <div class="d-flex service justify-content-between mt-4">
                <span>+ {{ orderServicePriceAdditive.ServicePriceAdditive.Attribute.AttributeTitle | translate }}</span>
                <div class="d-flex gap-1">
                  <p
                    style="font-size: 12px!important;color: rgba(19, 20, 31, 0.9)!important;">{{ getCountAndPriceOfServicePriceAdditive(factorOrder.Order.OrderServicePriceAdditives, orderServicePriceAdditive.ServicePriceAdditive.AttributeId).Count > 1 ? (factorOrder.Order.Count + '×') : '' }}
                  </p>
                  <p
                    style="font-family: IRANSansWebBold!important;">{{ getCountAndPriceOfServicePriceAdditive(factorOrder.Order.OrderServicePriceAdditives, orderServicePriceAdditive.ServicePriceAdditive.AttributeId).TotalPrice === 0 ? 'رایگان' : getCountAndPriceOfServicePriceAdditive(factorOrder.Order.OrderServicePriceAdditives, orderServicePriceAdditive.ServicePriceAdditive.AttributeId).TotalPrice + ' ریال' }}
                  </p>
                </div>
              </div>
            }
          }
        </div>
      }
      @if (parseInt(data.Price) === parseInt(data.PayablePrice)) {
        <div style="border-bottom: 1px solid #E3E1E1;margin-right: 16px;margin-left: 16px"></div>
      }
    </div>
    <div class="financial-box">
      @if (parseInt(data.Price) !== parseInt(data.PayablePrice)) {
        <div class="financial-content">
          <div class="d-flex align-items-center justify-content-between mt-3">
            <span>{{ 'Sum' | translate }}</span>
            <p>{{ StringUtil.numberAsCurrency(data.Price ?? 0) + ' ریال' }}</p>
          </div>
          @if (parseInt(data.TaxPrice) > 0) {
            <div class="d-flex align-items-center justify-content-between mt-4">
              <span
                style="font-family: IRANSansWeb!important;color: rgba(19, 20, 31, 0.6)!important;">{{ 'ValueAddedTax' | translate }}</span>
              <p>{{ StringUtil.numberAsCurrency(data.TaxPrice) + ' ریال' }}</p>
            </div>
          }
          @if (parseInt(data.DeliveryPrice) > 0) {
            <div class="d-flex align-items-center justify-content-between mt-4">
              <span
                style="font-family: IRANSansWeb!important;color: rgba(19, 20, 31, 0.6)!important;">{{ 'ShippingCost' | translate }}</span>
              <p>{{ StringUtil.numberAsCurrency(data.DeliveryPrice) + ' ریال' }}</p>
            </div>
          }
        </div>
      }
      <div class="d-flex align-items-center justify-content-between payable">
        <span>{{ 'TotalSum' | translate }}</span>
        <p
          style="font-family: IRANSansWebBold!important;">{{ StringUtil.numberAsCurrency(data.PayablePrice ?? 0) + 'ریال' }}
        </p>
      </div>
    </div>
  </div>
</div>
